<template>
  <!-- Save to projects pop up -->
  <div class="headwrap" v-bind:class="{positionfix: scrollPosition > 35}">
    <b-modal
      id="minicart-saveto-project"
      ref="minicart-popupmodal"
      title="Save to Projects"
      title-tag="h3"
      ok-only
      modal-class="common_pop saveto_project"
    >
      <div v-if="!showclient && !shownewproject && !shownewclient" class="projectoptions">
        <h3>Save to Projects</h3>
        <ul>
          <li>
            <a
              href="javascript:;"
              @click="showclient = !showclient"
            >Existing Client - Existing Project</a>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="shownewproject = !shownewproject"
            >Existing Client - New Project</a>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="shownewclient = !shownewclient"
            >New Client- New Project</a>
          </li>
        </ul>
      </div>
      <div v-if="showclient" class="savetoclient">
        <a @click="(showclient = !showclient); resetModelForm();" href="javascript:;">
          <b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back
        </a>
        <h3>Save to Existing Client- Project</h3>
        <b-form class="commonform" @submit="Submit1Popup">
          <div class="row">
            <div
              class="col"
              :state="!form1.errors.has('client')"
              :class="form1.errors.get('client')?'haserror forstar':'forstar'"
              :invalid-feedback="form1.errors.get('client')"
            >
              <label class="setuplabel">Select a Client</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form1.errors.has('client')"
                  @input="form1.errors.clear('client'); getProjects();"
                  :options="clientscart"
                  :reduce="clientscart => clientscart.value"
                  label="text"
                  v-model="form1.client"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form1.errors.get('client')">Required Field</span>
              </div>
            </div>
          </div>
          <div class="row showProject">
            <div
              class="col"
              :state="!form1.errors.has('project')"
              :class="form1.errors.get('project')?'haserror forstar':'forstar'"
              :invalid-feedback="form1.errors.get('project')"
            >
              <label class="setuplabel">Select a Project</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form1.errors.has('project')"
                  @input="form1.errors.clear('project')"
                  :options="projects"
                  :reduce="projects => projects.value"
                  label="text"
                  v-model="form1.project"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form1.errors.get('project')">Required Field</span>
              </div>
            </div>
          </div>
          <b-button block type="submit" variant="dark">Add</b-button>
          <span class="error-msg" v-if="this.form1.error_name!=''">{{this.form1.error_name}}</span>
        </b-form>
      </div>
      <div v-if="shownewproject" class="savetoclient">
        <a @click="(shownewproject = !shownewproject); resetModelForm();" href="javascript:;">
          <b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back
        </a>
        <h3>Save to New Project of Existing Client</h3>
        <b-form class="commonform" @submit="Submit2Popup">
          <div class="row">
            <div
              class="col"
              :state="!form2.errors.has('client_id')"
              :class="form2.errors.get('client_id')?'haserror forstar':'forstar'"
              :invalid-feedback="form2.errors.get('client_id')"
            >
              <label class="setuplabel">Select a Client</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form2.errors.has('client_id')"
                  @input="form2.errors.clear('client_id'); showProject1();"
                  :options="clientscart"
                  :reduce="clientscart => clientscart.value"
                  label="text"
                  v-model="form2.client_id"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form2.errors.get('client_id')">Required Field</span>
              </div>
            </div>
          </div>
          <div class="row showProject1">
            <div class="col">
              <md-field
                :state="!form2.errors.has('name')"
                :class="form2.errors.get('name')?'haserror forstar':'forstar'"
                :invalid-feedback="form2.errors.get('name')"
              >
                <label class="setuplabel">Create and save to new project</label>
                <md-input
                  :state="!form2.errors.has('name')"
                  @input="form2.errors.clear('name')"
                  v-model="form2.name"
                ></md-input>

                <span
                  class="error-msg"
                  v-if="form2.errors.get('name')"
                >{{form2.errors.get('name')=="The name field is required."?'Required Field':form2.errors.get('name')}}</span>
              </md-field>
            </div>
          </div>
          <b-button block type="submit" variant="dark">Add</b-button>
          <span class="error-msg" v-if="this.form2.error_name!=''">{{this.form2.error_name}}</span>
        </b-form>
      </div>
      <div v-if="shownewclient" class="savetoclient newcreation">
        <a @click="(shownewclient = !shownewclient); resetModelForm();" href="javascript:;">
          <b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back
        </a>
        <h3>Save to New Client- Project</h3>
        <b-form class="commonform" @submit="Submit3Popup">
          <md-field
            :state="!form.errors.has('createclient')"
            :class="form.errors.get('createclient')?'haserror forstar':'forstar'"
            :invalid-feedback="form.errors.get('createclient')"
          >
            <label>Create a new client</label>
            <md-input
              :state="!form.errors.has('createclient')"
              @input="form.errors.clear('createclient'); showProject2();"
              v-model="form.createclient"
            ></md-input>
            <span
              class="error-msg"
              v-if="form.errors.get('createclient')"
            >{{form.errors.get('createclient')=="The createclient field is required."?'Required Field':form.errors.get('createclient')}}</span>
          </md-field>
          <md-field
            :state="!form.errors.has('createproject')"
            :class="form.errors.get('createproject')?'haserror forstar showProject2':'forstar showProject2'"
            :invalid-feedback="form.errors.get('createproject')"
          >
            <label>Create a new project</label>
            <md-input
              :state="!form.errors.has('createproject')"
              @input="form.errors.clear('createproject')"
              v-model="form.createproject"
            ></md-input>
            <span
              class="error-msg"
              v-if="form.errors.get('createproject')"
            >{{form.errors.get('createproject')=="The createproject field is required."?'Required Field':form.errors.get('createproject')}}</span>
          </md-field>
          <b-button block type="submit" variant="dark">Add</b-button>
          <span class="error-msg" v-if="this.form.error_name!=''">{{this.form.error_name}}</span>
        </b-form>
      </div>
    </b-modal>

    <b-modal
      id="success-save-project"
      ref="success-modal"
      :title="this.successtitle"
      title-tag="h3"
      ok-only
      modal-class="common_pop save_project"
    >
    </b-modal>

    <b-modal
      id="impersonate_search_popup"
      ref="impersonate_search_popup"
      title="Search For Account"
      title-tag="h3"
      ok-only
      modal-class="common_pop impersonate_search">
    <form class="commonform" method="GET" action="/shop/impersonate-account">
        <b-row>
          <b-col>
            <md-field class="forstar">
              <label>Search Account Number, Name Or Email</label>
              <md-input name="account" type="text" required></md-input>
            </md-field>
          </b-col>
        </b-row>
        <b-button type="submit" block variant="dark">
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9707 12.3796H13.6291L17.7874 16.5462L16.5457 17.7879L12.3791 13.6296V12.9712L12.1541 12.7379C11.2041 13.5546 9.97074 14.0462 8.62907 14.0462C5.6374 14.0462 3.2124 11.6212 3.2124 8.62956C3.2124 5.63789 5.6374 3.21289 8.62907 3.21289C11.6207 3.21289 14.0457 5.63789 14.0457 8.62956C14.0457 9.97122 13.5541 11.2046 12.7374 12.1546L12.9707 12.3796ZM4.87907 8.62956C4.87907 10.7046 6.55407 12.3796 8.62907 12.3796C10.7041 12.3796 12.3791 10.7046 12.3791 8.62956C12.3791 6.55456 10.7041 4.87956 8.62907 4.87956C6.55407 4.87956 4.87907 6.55456 4.87907 8.62956Z" fill="white"/>
          </svg>
          Search
        </b-button>
      </form>
    </b-modal>
    <div v-html="top_header"></div>
    <header
      id="masthead"
      class="site-header"
      v-bind:class="{headfix: scrollPosition > 35}"
      role="banner"
    >
      <div class="container">
        <div class="inner_header">
          <div class="logosec">
            <a href="/">
              <b-img class="logo" src="/shop/images/rmcoco_new.webp" alt="logo"></b-img>
            </a>
            <!-- <a class="formob" href="javascript:;">
              <i class="fa fa-bars"></i>
            </a>-->
          </div>
          <div class="search-account">
            <div class="searchform">
              <div class="searchsite">
                <input
                  type="search"
                  v-model="searchtext"
                  placeholder="search by name, color, type, or pattern"
                  v-on:keyup.enter="onSearch"
                />
                <span @click="onSearch"></span>
              </div>
              <div class="searchimg">
                <a href="#">
                  <div>
                    <b-img
                      class="cameraicn"
                      src="/shop/images/photo-camera.svg"
                      alt="Photo camera image"
                    ></b-img>
                  </div>
                  <span>
                    COCO
                    Match
                  </span>
                </a>
              </div>
            </div>
            <div class="accountcart">
              <div class="impersonatesec" v-if="user.reporadmin == '1' || user.reporadmin == '2'">
                <button @click="openImpersonateSearch" class="btn">Impersonate Account</button>
              </div>
              <div class="accountsec">
                <a v-bind:class="{ 'isloggedin': user.id > 0 }" href="javascript:;" v-if="user.id && user.parent_user_id">
                  <b-img class="headimg" src="/shop/images/user.svg" alt="User image"></b-img>
                  <span>Welcome {{user.parent_user_firstname | capitalize}}</span>
                  <span>&#9679; Account {{user.accountnumber}} - {{user.companyname}}</span>
                </a>
                <a v-bind:class="{ 'isloggedin': user.id > 0 }" href="javascript:;" v-else-if="user.id && !user.parent_user_id">
                  <b-img class="headimg" src="/shop/images/user.svg" alt="User image"></b-img>
                  <span>Welcome {{user.firstname | capitalize}}</span>
                </a>
                <a href="/shop/login" v-else>
                  <b-img class="headimg" src="/shop/images/user.svg" alt="User image"></b-img><span>Sign
                  in/Register</span>
                </a>
                <ul v-if="user.id">
                  <li>
                    <a href="/shop/account">Account</a>
                  </li>
                  <li>
                    <a href="/shop/orders">Orders</a>
                  </li>
                  <li>
                    <a href="/shop/invoices">Invoices</a>
                  </li>
                  <li>
                    <a href="/shop/projects">Projects</a>
                  </li>
                  <li>
                    <a href="/customer-resources/">Customer Resources</a>
                  </li>
                  <li>
                    <a href="/shop/pricesheet">Price Sheet By Book</a>
                  </li>
                  <li v-if="user.id && user.parent_user_id">
                    <a href="#" @click.prevent="logoutChild">
                      <img class="signout" src="/shop/images/signout.svg" />Sign Out
                    </a>
                  </li>
                  <li v-else>
                    <a href="#" @click.prevent="logout">
                      <img class="signout" src="/shop/images/signout.svg" />Sign Out
                    </a>
                  </li>
                </ul>
              </div>
              <div class="cartsec" v-click-outside="hideMinicart">
                <a v-if="user.id" v-on:click="isseen = !isseen">
                  <b-img class="headimg" src="/shop/images/cart.svg" alt="Cart image"></b-img>
                  <span class="itemcount">{{inCartItems.ITEMS.length}}</span>
                </a>
                <a v-else href="/shop/login">
                  <b-img class="headimg" src="/shop/images/cart.svg" alt="Cart image"></b-img>
                </a>
                <div v-if="!isseen && inCartItems.ITEMS.length > 0" class="cartitems">
                  <div class="itemcount">
                    <div>
                      <span>{{inCartItems.ITEMS.length}}</span> item in Cart
                    </div>
                    <div>
                      Item total
                      <span>${{inCartItems.total}}</span>
                    </div>
                  </div>
                  <div class="cartitems-inner">
                    <perfect-scrollbar>
                      <div class="iteminfo" v-for="(mc,mck) in inCartItems.ITEMS" :key="mck">
                        <div class="cartboximg">
                          <b-img class="incartimg" :src="mc.SMALL_IMAGE" fluid alt="main image"></b-img>
                        </div>
                        <div class="cartboxcontent">
                          <template v-if="mc.ITEMID == 'CW000'">
                            <h3>Custom Print</h3>
                          </template>
                          <template v-if="mc.ORDERTYPE == 'CDI'">
                            <h3>{{mc.ITEMNAME}}</h3>
                          </template>
                          <template v-else>
                            <h3>{{mc.ITEMNAME}} - {{mc.COLORNAME}}</h3>
                          </template>
                          <a href="javascript:;" @click="removeMinicartItem(mc.ID)" :data-id="mc.ID">
                            <b-img
                              class="cartdelete"
                              src="/shop/images/close.svg"
                              fluid
                              alt="close image"
                            ></b-img>
                          </a>
                          <p>
                            <template v-if="mc.ITEMID == 'CW000'">
                              {{mc.ITEMID}}
                            </template>
                            <template v-else>
                              <span>Color:</span>
                              {{mc.COLORNAME}} {{mc.ITEMID}}-{{mc.INVENTCOLORID}}
                            </template>
                          </p>
                          <p v-if="mc.BASEFABRICNAME">
                            <template>
                              <span>Base Fabric:</span>
                              {{mc.BASEFABRICNAME}}
                            </template>
                          </p>
                          <p>
                            <span>Qty:</span>
                            {{mc.QTY}}
                          </p>
                          <div class="bookmarkprice">
                            <span v-if="(mc.PC_TYPE = 'Sample' && mc.BASEFABRICNAME) || mc.PC_TYPE == 'fauxfur'"></span>
                            <a
                              v-else
                              v-show="mc.ORDERTYPE.toLowerCase() != 'holdtendays'"
                              href="javascript:;"
                              @click="(mc.ORDERTYPE =='CDI')?showSavePromoToProject(mc.CDI_ID):Showsavetoproject(mc.ID);"
                            >
                              <b-img
                                class="bookmarkimg"
                                src="/shop/images/bookmark.svg"
                                fluid
                                alt="bookmark image"
                              ></b-img>
                            </a>
                            <h3>$ {{mc.TOTAL}}</h3>
                          </div>
                        </div>
                      </div>
                    </perfect-scrollbar>
                  </div>
                  <div class="buttonsec">
                    <b-button block variant="dark" @click="redirectCheckout">Proceed to Checkout</b-button>
                    <a href="/shop/cart">
                      <b-img class="viewcart" src="/shop/images/cart.svg" fluid alt="cart image"></b-img>View Cart
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="navigation-top">
            <ul class="menu" v-click-outside="handleClickOutside">
              <li
                v-for="(result, index) in main_menu"
                :key="index"
                :class="result.classes && result.classes.length>0?result.classes.join().replace(/,/g, ' ')+' menu-item-'+result.ID:'menu-item-'+result.ID"
              >
                <a :href="result.url" v-html="result.title" @click.prevent="handleMenuClick(result, $event)"></a>

                <div class="wrapview" v-if="result.wpse_children" :style="{ display: openMenuId === result.ID ? 'block' : 'none' }">
                  <ul class="sub-menu level-1">
                    <li
                      v-for="(resultwp, indexwp) in sortArrays(result.wpse_children)"
                      :key="indexwp"
                      :class="resultwp.classes && resultwp.classes.length>0?resultwp.classes.join().replace(/,/g, ' ')+' menu-item-'+resultwp.ID:'menu-item-'+resultwp.ID"
                    >
                      <a :href="resultwp.url" v-html="resultwp.title"></a>
                      <ul class="sub-menu level-2" v-if="resultwp.wpse_children">
                        <li
                          v-for="(resultwpsub, indexwpsub) in resultwp.wpse_children"
                          :key="indexwpsub"
                          :class="resultwpsub.classes && resultwpsub.classes.length>0?resultwpsub.classes.join().replace(/,/g, ' ')+' menu-item-'+resultwpsub.ID:'menu-item-'+resultwpsub.ID"
                        >
                        <a :href="resultwpsub.url" v-html="resultwpsub.title"></a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <div class="furniture-images-div" v-html="furniture_menu" v-if="result.ID=='18'"></div>
                  <div class="furniture-images-div" v-html="workroom_menu" v-if="result.ID=='777'"></div>
                  <div class="furniture-images-div" v-html="contract_menu" v-if="result.ID=='21'"></div>
                  <div class="furniture-images-div" v-html="company_menu" v-if="result.ID=='15'"></div>
                  <div class="furniture-images-div" v-html="customprint_menu" v-if="result.ID=='10125'"></div>
                  <div class="furniture-images-div" v-html="shades_menu" v-if="result.ID=='20023'"></div>
                  <div class="fabric-filters" v-if="result.ID=='14'">
                    <div class="submenu" v-for="(result, index) in fabric_menu" :key="index">
                      <h4>{{ index }}</h4>
                      <ul>
                        <li v-for="(subresult, subindex) in result" :key="subindex">
                          <a :href="subresult.link">{{ subresult.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="trim-filters" v-if="result.ID=='16'">
                    <div v-for="(result, index) in trim_menu" :key="index">
                      <h4>{{ index }}</h4>
                      <ul>
                        <li v-for="(subresult, subindex) in result" :key="subindex">
                          <a :href="subresult.link">{{ subresult.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="furniture-images-div" v-html="hardware_menu" v-if="result.ID=='17'"></div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
	  <Slide class="mobilemenu">
      <div v-for="(result, index) in main_menu" :key="index">
        <a :href="result.url" v-b-toggle="'mobmenu-'+result.ID">
          <span v-html="result.title"></span>
          <img src="/shop/images/arrow.svg" alt="arrow image" class="submenuarrow" v-if="result.wpse_children">
        </a>
        <b-collapse v-if="result.wpse_children" :id="'mobmenu-'+result.ID" accordion="my-accordion" role="tabpanel">
          <ul class="submoboptions level-1">
            <li 
              v-for="(resultwp, indexwp) in sortArrays(result.wpse_children)"
              :key="indexwp"
              :class="'menu-item-'+resultwp.ID">
              <div>
                <a :href="resultwp.url" v-b-toggle="'mobmenu-sub-'+resultwp.ID">
                  <span v-html="resultwp.title"></span>
                  <img src="/shop/images/arrow.svg" alt="arrow image" class="submenuarrow" v-if="resultwp.wpse_children">
                </a>
                <b-collapse v-if="result.wpse_children" :id="'mobmenu-sub-'+resultwp.ID" accordion="my-accordion-sub" role="tabpanel">
                    <ul class="submoboptions level-2" v-if="resultwp.wpse_children">
                      <li
                        v-for="(resultwpsub, indexwpsub) in resultwp.wpse_children"
                        :key="indexwpsub"
                        :class="'menu-item-'+resultwpsub.ID"
                      >
                        <a :href="resultwpsub.url" v-html="resultwpsub.title"></a>
                      </li>
                    </ul>
                </b-collapse>
              </div>
            </li>
          </ul>
        </b-collapse>
      </div>
      <div>
        <div class="impersonatesec" v-if="user.reporadmin == '1' || user.reporadmin == '2'">
          <a href="/shop/impersonate-account?account=" class="btn">Impersonate Account</a>
        </div>
      </div>
    </Slide>
    <ProjectModal ref="project" />

  </div>
</template>
<script>
import ResourceMixin from "../mixins/resources";
import ProjectModal from "@/views/ProjectModal/ProjectModal.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import ClickOutside from "vue-click-outside";
import { ModelSelect } from "vue-search-select";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Slide } from 'vue-burger-menu'
export default {
  name: "CommonHead",
  components: {
    ModelSelect,
    ProjectModal,

	Slide,
    "v-select": vSelect
  },
  mixins: [ResourceMixin],
  data() {
    return {
      scrollPosition: null,
      logoutForm: new Form({}),
      fabric_menu: [{}],
      trim_menu: [{}],
      hardware_menu: [{}],
      main_menu: [{}],
      furniture_menu: [{}],
      workroom_menu: [{}],
      contract_menu: [{}],
      company_menu: [{}],
      customprint_menu: [{}],
      shades_menu: [{}],
      top_header:[{}],
      openMenuId: null,
      isseen: true,
      searchtext: "",
      successtitle: "",
      HIDEMESTATIC:true,
      form: new Form({
        createclient: "",
        createproject: "",
        product_id: "",
        inventcolorid: "",
        pc_type: "",
        order_type: "",
        notes: "",
        quantity: "",
        user_id: "",
        cart: "",
        error_name: ""
      }),
      form1: new Form({
        client: "",
        project: "",
        product_id: "",
        inventcolorid: "",
        pc_type: "",
        order_type: "",
        notes: "",
        quantity: "",
        user_id: "",
        cart: "",
        error_name: ""
      }),
      form2: new Form({
        client_id: "",
        name: "",
        product_id: "",
        inventcolorid: "",
        pc_type: "",
        order_type: "",
        notes: "",
        quantity: "",
        user_id: "",
        cart: "",
        error_name: ""
      }),
      showclient: false,
      cart: "",
      user_id: "",
      shownewproject: false,
      shownewclient: false,
      isCartempty: false,
      clientscart: [
        { value: "1", text: "James" },
        { value: "2", text: "Mathew" },
        { value: "3", text: "John" },
        { value: "4", text: "Nick" }
      ],
      projects: [
        { value: "1", text: "Lorem" },
        { value: "2", text: "Ipsum" },
        { value: "3", text: "Dolor" },
        { value: "4", text: "Lorem" }
      ],
      saveprojectcart: [
        { value: "1", text: "Lorem" },
        { value: "2", text: "Ipsum" },
        { value: "3", text: "Dolor" },
        { value: "4", text: "Lorem" }
      ]
    };
  },
  computed: {
    ...mapGetters(["user", "cartproducts"]),
    inCartItems() {
      return this.cartproducts;
    }
  },
  methods: {
	  togglemobmenu(){
			$(".submoboptions").toggle();
		},
    handleMenuClick(menu, event) {
      const href = menu.url?.trim();

      // If it's a real URL (not # or empty), navigate
      if (href && href !== "#") {
        window.location.href = href;
        return;
      }

      // Otherwise toggle dropdown
      if (this.openMenuId === menu.ID) {
        this.openMenuId = null; // close
      } else {
        this.openMenuId = menu.ID; // open this one
      }
    },
    handleClickOutside(event) {
      this.openMenuId = null; // close
    },
    onSearch() {
      if (this.searchtext != "") {
        window.location = "/shop/search/" + this.searchtext;
      }
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    sortArrays(arrays) {
      return _.orderBy(arrays, "menu_order", "asc");
    },
    logout() {
      this.$store.dispatch("logout", this.logoutForm).then(() => {
        this.$router.replace({ name: "login" });
        this.$notify("You've been logged out.");
      });
    },
    logoutChild(){
      this.$store.dispatch("logoutChild", this.logoutForm).then(() => {
        this.$notify("You've been logged out.");
        window.location = '/shop/account';        
      });
    },
    loadCartItems(user_id) {
      //this.isLoading = true;
      this.$store.dispatch("loadCart", user_id).then(minicart => {
        //this.isLoading = true;
        $(".iteminfo").removeClass("is_removing");
        if(minicart.data.ITEMS.length < 1){
          $(".AddTOCartBtn").removeAttr("disabled");
          $(".AddTOCartBtn").css("cursor", "pointer");
        }
      });
    },
    removeMinicartItem(id) {
      $(".iteminfo a[data-id='"+id+"']").parents(".iteminfo").addClass("is_removing");
      this.$store.dispatch("deleteCartItem", {id:id,user_id:this.user.accountnumber}).finally(() => {
        //this.isLoading = true;
        this.loadCartItems(this.user.accountnumber);
      });
    },
    redirectCheckout() {
      this.$router.push("/shop/checkout");
    },
    Submit1Popup(evt) {
      evt.preventDefault();

      this.form1.cart = this.cart;
      this.form1.user_id = this.user.accountnumber;

      //this.isLoading = true;
      this.$store
        .dispatch("AddProductToProject", {
          form: this.form1
        })
        .then(response => {
          if (response.data.success) {
            this.form1.error_name = "";
            if (this.user.id > 0) {
              this.loadCartItems(this.user.accountnumber);
            }

            this.$notify({
              text: "Product added successfully",
              type: "success"
            });
            this.form1 = new Form({
              client: null,
              project: null,
              cart: this.cart,
              user_id: this.user.accountnumber,
              error_name: ""
            });
            this.$refs["minicart-popupmodal"].hide();
            /*this.successtitle="Product added successfully";
		   this.$refs["success-modal"].show();*/
          } else {
            this.$notify({
              text: "please try again!",
              type: "error"
            });

            this.form1.error_name = response.data.error;
          }
        });
      //this.isLoading = false;
    },
    Submit2Popup(evt) {
      evt.preventDefault();

      this.form2.cart = this.cart;
      this.form2.user_id = this.user.accountnumber;

      //this.isLoading = true;
      this.$store
        .dispatch("AddProject", {
          form: this.form2
        })
        .then(response => {
          if (response.data.success) {
            this.form2.error_name = "";
            this.$notify({
              text: "Product added successfully",
              type: "success"
            });
            if (this.user.id > 0) {
              this.loadCartItems(this.user.accountnumber);
            }
            this.form2 = new Form({
              client_id: null,
              name: null,
              cart: this.cart,
              user_id: this.user.accountnumber,
              error_name: ""
            });
            this.$refs["minicart-popupmodal"].hide();
            /*this.successtitle="Product added successfully";
		   this.$refs["success-modal"].show();*/
          } else {
            this.$notify({
              text: "please try again!",
              type: "error"
            });

            this.form2.error_name = response.data.error;
          }
        });
      //this.isLoading = false;
    },
    Submit3Popup(evt) {
      evt.preventDefault();

      this.form.cart = this.cart;
      this.form.user_id = this.user.accountnumber;

      //this.isLoading = true;
      this.$store
        .dispatch("AddClientAndProject", {
          form: this.form
        })
        .then(response => {
          if (response.data.success) {
            this.form.error_name = "";
            //update clients dropdown
            this.LoadClients();

            this.$notify({
              text: "Project added successfully",
              type: "success"
            });
            if (this.user.id > 0) {
              this.loadCartItems(this.user.accountnumber);
            }
            this.form = new Form({
              createclient: null,
              createproject: null,
              cart: this.cart,
              user_id: this.user.accountnumber,
              error_name: ""
            });

            this.$refs["minicart-popupmodal"].hide();
            /*this.successtitle="Product added successfully";
		   this.$refs["success-modal"].show();*/
          } else {
            this.$notify({
              text: "please try again!",
              type: "error"
            });
            this.form.error_name = response.data.error;
          }
        });
      //this.isLoading = false;
    },
    Showsavetoproject(cur_cart) {
      this.resetModelForm();
      this.cart = cur_cart;
      this.$refs["minicart-popupmodal"].show();
    },
    ShowsavetoprojectAll() {
      this.resetModelForm();
      this.cart = "all";
      this.$refs["minicart-popupmodal"].show();
    },
    resetModelForm() {
      $(".ordertype.type .error-msg").remove();
      $(".savetoclient .error-msg").remove();
      this.showclient = false;
      this.shownewproject = false;
      this.shownewclient = false;
      //reset forms
      this.cart = "";
      this.user_id = "";

      this.form.createclient = "";
      this.form.createproject = "";
      this.form.product_id = "";
      this.form.inventcolorid = "";
      this.form.pc_type = "";
      this.form.order_type = "";
      this.form.notes = "";
      this.form.quantity = "";
      this.form.user_id = "";
      this.form.cart = "";
      this.form.error_name = "";

      this.form1.client = "";
      this.form1.project = "";
      this.form1.product_id = "";
      this.form1.inventcolorid = "";
      this.form1.pc_type = "";
      this.form1.order_type = "";
      this.form1.notes = "";
      this.form1.quantity = "";
      this.form1.user_id = "";
      this.form1.cart = "";
      this.form1.error_name = "";

      this.form2.client_id = "";
      this.form2.name = "";
      this.form2.product_id = "";
      this.form2.inventcolorid = "";
      this.form2.pc_type = "";
      this.form2.order_type = "";
      this.form2.notes = "";
      this.form2.quantity = "";
      this.form2.user_id = "";
      this.form2.cart = "";
      this.form2.error_name = "";
    },
    getProjects() {
      if (this.form1.client) {
        $(".showProject").show();
        this.$store
          .dispatch("LoadClientProjects", this.form1.client)
          .then(loadprojects => {
            this.projects = loadprojects.data;
          });
      } else {
        $(".showProject").hide();
      }
    },
    showProject1() {
      if (this.form2.client_id) {
        $(".showProject1").show();
      } else {
        $(".showProject1").hide();
      }
    },
    showProject2() {
      if (this.form.createclient) {
        $(".showProject2").show();
      } else {
        $(".showProject2").hide();
      }
    },
    showSavePromoToProject(cdi) { 
      if(this.cartproducts.ITEMS[0].PC_TYPE == 'CDIP'){
        this.$refs.project.show(cdi,"1");
      }else{
        this.$refs.project.show(cdi,"0");
      }
    },
    LoadClients() {
      if (this.user.id > 0) {
        this.$store
          .dispatch("LoadClient", this.user.accountnumber)
          .then(loadclients => {
            this.clientscart = loadclients.data;
          });
      }
    },
    hideMinicart() {
      this.isseen = true;
    },
    openImpersonateSearch(){
      this.$refs["impersonate_search_popup"].show();
    }
  },
  mounted() {
    this.LoadClients();

    if (this.user.id > 0) {
      this.loadCartItems(this.user.accountnumber);
    }
        window.addEventListener("scroll", this.updateScroll);
    //axios.get("/shop/api/wp-menu").then(response => {
      let response = {data:window.__menu};
      this.main_menu = response.data.wpMenuApi;
      this.fabric_menu = response.data.fabricMenu;
      this.trim_menu = response.data.trimMenu;
      this.furniture_menu = response.data.wpFurnitureMenu;
      this.workroom_menu = response.data.wpWorkroomMenu;
      this.contract_menu = response.data.wpContractMenu;
      this.company_menu = response.data.wpCompanyMenu;
      this.customprint_menu = response.data.wpCustomPrintMenu;
      this.shades_menu = response.data.wpShadesMenu;
      this.hardware_menu = response.data.wpHardwareMenu;
      this.top_header = response.data.wpTopHeader;
      // if (this.user.id < 1) {
      //   setTimeout(() => {
      //     $("header .inner_header .navigation-top ul > li.sub_furniture .wrapview ul.sub-menu li.ins-resources a").attr("href","/shop/login");
      //   }, 200);
      // }
    //});
  },
  directives: {
    ClickOutside
  }
};
</script>
<style>
.mobilemenu {
  display: none;
}

header.site-header {
  height: 120px;
  box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.2);
  position: relative;
  width: 100%;
  background: #fff;
  z-index: 10;
}

header.site-header.headfix {
  position: fixed;
  top: 0;
  background: #fff;
  z-index: 11;
}

header .logosec {
  margin: 10px 65px 10px 0;
  /* display: inline-block; */
  width: auto;
  float: left;
}

header .inner_header {
  height: 90px;
  position: relative;
  margin: 0;
  padding: 0;
}

header .inner_header .navigation-top {
  width: 100%;
  float: right;
}

header .inner_header .navigation-top ul.menu {
  display: flex;
  justify-content: space-between;
  margin-top: 0;
}

header .inner_header .navigation-top ul>li {
  line-height: normal;
  height: 40px;
  line-height: 40px;
  padding: 0 38px;
  box-sizing: border-box;
  flex: 1;
}

header .inner_header .navigation-top ul>li.fabric_item {
  padding-left: 0;
}

header .inner_header .navigation-top ul>li.sub_contract {
  padding-right: 0;
}

header .inner_header .navigation-top ul>li.menucustomprint {
  white-space: nowrap;
}

header .inner_header .navigation-top ul>li.menucustomprint > a{
  text-align: center;
  line-height: 20px;
}

header .inner_header .navigation-top ul>li .wrapview::after {
  content: "";
  position: absolute;
  width: 106%;
  height: 101%;
  top: -10px;
  z-index: -1;
  left: -3%;
  max-width: 100vw;
}

/* header .inner_header .navigation-top ul>li .wrapview::before {
  content: "";
  position: absolute;
  width: 18.3%;
  height: 41px;
  top: -36px;
  z-index: -50;
  left: 0px;
  max-width: 100vw;
} */

header .inner_header .navigation-top ul>li.sub_company .wrapview ul li.menu-item-4984,
header .inner_header .navigation-top ul>li.sub_company .wrapview ul li.menu-item-4985 {
  float: none;
}

header .inner_header .navigation-top ul>li.sub_company .wrapview ul li.menu-item-4985 {
  margin-top: -5px !important;
}

/*header .inner_header .navigation-top ul > li.sub_company .wrapview ul li.menu-item-313{
	top:-15px;
	margin-bottom:20px;
}*/

header .inner_header .navigation-top ul>li.sub_furniture.sub_workroom .wrapview ul.sub-menu li.menu-item-4672 {
  margin-bottom: 15px;
}

header .inner_header .navigation-top ul>li.sub_contract .wrapview ul li.ten-trends {
  margin-bottom: 50px !important;
}

header .inner_header .navigation-top ul>li.sub_furniture.sub_company .wrapview ul.sub-menu li {
  margin-right: 0;
  width: 100%;
  overflow: hidden;
}

header .inner_header .navigation-top ul>li>a {
  float: left;
  color: #303030;
  font-size: 14px;
  text-decoration: none;
  position: relative;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
}

header .inner_header .navigation-top ul>li>ul.sub-menu {
  display: none;
  border: 1px solid #d2d2d2;
  position: absolute;
  width: 100%;
  background: #fff;
  z-index: 1;
  top: 89px;
  padding: 15px 30px 0 30px;
  left: 0;
}

header .inner_header .navigation-top ul>li:last-child>ul.sub-menu {
  right: 0;
}

header .inner_header .navigation-top ul>li>a:hover {
  text-shadow: 0px 0px 1px #303030;
}

header .inner_header .navigation-top ul>li>a::before {
  content: "";
  height: 2px;
  width: 100%;
  background-color: #202020;
  position: absolute;
  bottom: 0;
  left: 0;
  visibility: hidden;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transition: all 0.5s ease-in-out 0s;
  transition: all 0.5s ease-in-out 0s;
}

header .inner_header .navigation-top ul li svg.icon.icon-angle-down {
  display: none;
}

header .inner_header .navigation-top ul>li:hover>ul.sub-menu {
  display: block;
}

header .inner_header .navigation-top ul>li:hover>a::before {
  visibility: visible;
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}

header .inner_header .navigation-top ul li>ul.sub-menu>li {
  padding-bottom: 0;
  height: 24px;
  line-height: 24px;
  width: 100%;
  display: inline-block;
}

header .inner_header .navigation-top ul li>ul.sub-menu>li>a {
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  color: #303030;
  font-weight: 600;
  display: inline-block;
  padding-bottom: 0;
  word-break: break-all;
}

header .inner_header .navigation-top ul li>ul.sub-menu>li a::before {
  display: none;
}

header .inner_header .navigation-top ul li>ul.sub-menu>li a:hover {
  border-bottom: 1px solid #303030;
  text-shadow: none;
}

header .inner_header .navigation-top ul li>ul.sub-menu>li>ul.sub-menu {
  position: relative;
  top: 5px;
  border: 0;
  padding: 0;
  background: transparent;
  width: auto;
  min-width: auto;
  z-index: inherit;
  display: block;
}

header .inner_header .navigation-top ul li>ul.sub-menu>li>ul.sub-menu>li>a {
  font-weight: 400;
}

.headwrap.positionfix+.container {
  margin-top: 130px;
}

header .container img {
  width: 165px;
  height: 52px;
}

header button.toggle.close-nav-toggle.fill-children-current-color {
  display: none;
}

.head_top {
  background: #42996e;
  height: 35px;
  line-height: 35px;
}

.head_top .textwidget p a {
  text-decoration: underline;
}

.head_top p {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: inherit;
  text-align: center;
  padding: 0;
}

header .inner_header .search-account {
  width: 81.7%;
  display: flex;
  justify-content: space-between;
}

header .inner_header .search-account .searchform {
  flex-grow: 1;
  display: flex;
  flex-wrap: nowrap;
  margin-top: 15px;
  min-height: 37px;
}

header .inner_header .search-account .searchform .searchsite {
  position: relative;
  max-width: 380px;
  margin-right: 25px;
  min-width: 380px;
}

header .inner_header .search-account .searchform .searchsite span {
  cursor: pointer;
  background: url(/shop/images/search.svg) no-repeat center;
  height: 16px;
  width: 16px;
  position: absolute;
  top: 7px;
  right: 10px;
}

header .inner_header .search-account .searchform input {
  max-width: 380px;
  height: 30px;
  line-height: 15px;
  border: 1px solid #d2d2d2;
  font-size: 12px;
  color: #707070;
  padding: 5px 25px 5px 20px;
  width: 100%;
  font-family: "Spartan", sans-serif;
  outline: 0;
  border-radius: 3px;
  -webkit-appearance: none;
}

header .inner_header .search-account .searchform input[type="search"]::-webkit-search-cancel-button {
  position: relative;
  right: 20px;
  -webkit-appearance: none;
  height: 20px;
  width: 20px;
  border-radius: 10px;
  background: white;
}

header .inner_header .search-account .accountcart {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
}

header .inner_header .search-account .accountcart .cartsec {
  position: relative;
}

header .inner_header .search-account .accountcart .cartsec a {
  cursor: pointer;
}

header .inner_header .search-account .accountcart .cartsec a .itemcount {
  height: 17px;
  line-height: 16px;
  width: 17px;
  border: 1px solid #303030;
  border-radius: 50%;
  position: absolute;
  top: -4px;
  font-size: 9px;
  font-weight: 500;
  color: #303030;
  text-align: center;
  left: 13px;
  z-index: 1;
  background: #fff;
}

header .inner_header .search-account .accountcart .cartsec .cartitems {
  padding: 20px 0;
  border: 1px solid #d2d2d2;
  border-radius: 3px;
  position: absolute;
  width: 400px;
  right: 0;
  background: #fff;
  z-index: 11;
  top: 30px;
}

header .inner_header .search-account .accountcart .cartsec .cartitems .ps {
  height: 405px;
}

header .inner_header .search-account .accountcart .cartsec .cartitems .itemcount {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #303030;
  font-weight: 600;
  border-bottom: 1px solid #303030;
  padding: 0 20px 12px 20px;
}

header .inner_header .search-account .accountcart .cartsec .cartitems .itemcount span {
  font-size: 12px;
  color: #303030;
  font-weight: 600;
}

header .inner_header .search-account .accountcart .cartsec .cartitems .iteminfo {
  display: flex;
  justify-content: space-between;
  padding: 25px 0;
  border-bottom: 1px solid #303030;
  margin: 0 20px;
  position: relative;
}

header .inner_header .search-account .accountcart .cartsec .cartitems .iteminfo.is_removing:before {
  content: '';
  position: absolute;
  width: 100%;
  background: #fff;
  opacity: 0.8;
  left: 0;
  top: 0;
  height: 100%;
  z-index: 1;
}

header .inner_header .search-account .accountcart .cartsec .cartitems .iteminfo .cartboximg {
  height: 150px;
  width: 150px;
  border-radius: 3px;
  position: relative;
  overflow: hidden;
}

header .inner_header .search-account .accountcart .cartsec .cartitems .iteminfo .cartboximg img {
  width: 100%;
  height: auto;
}

header .inner_header .search-account .accountcart .cartsec .cartboxcontent {
  position: relative;
  width: 54%;
}

header .inner_header .search-account .accountcart .cartsec .cartboxcontent h3 {
  text-align: left;
  margin-bottom: 0;
}

header .inner_header .search-account .accountcart .cartsec .cartboxcontent p {
  font-size: 12px;
  color: #303030;
}

header .inner_header .search-account .accountcart .cartsec .cartboxcontent .cartdelete {
  height: 10px;
  width: 10px;
  position: absolute;
  right: 0;
  top: 0;
}

header .inner_header .search-account .accountcart .cartsec .cartboxcontent .bookmarkprice {
  position: relative;
  margin-top: 60px;
}

header .inner_header .search-account .accountcart .cartsec .cartboxcontent .bookmarkprice a {
  height: 25px;
  width: 25px;
  float: left;
  border: 1px solid #d2d2d2;
  border-radius: 3px;
  text-align: center;
}

header .inner_header .search-account .accountcart .cartsec .cartboxcontent .bookmarkprice a .bookmarkimg {
  height: 15px;
  width: 15ppx;
}

header .inner_header .search-account .accountcart .cartsec .cartboxcontent .bookmarkprice h3 {
  float: right;
  margin-top: 6px;
}

header .inner_header .search-account .accountcart .cartsec .buttonsec {
  display: flex;
  flex-wrap: wrap;
  padding: 32px 20px 0 20px;
}

header .inner_header .search-account .accountcart .cartsec .buttonsec a {
  color: #303030;
  text-align: center;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  margin-top: 30px;
  display: block;
  margin: 30px auto 0 auto;
  width: auto;
  border-bottom: 1px solid #fff;
}

header .inner_header .search-account .accountcart .cartsec a {
  opacity: 1;
}

header .inner_header .search-account .accountcart .cartsec a:hover {
  opacity: 0.8;
}

header .inner_header .search-account .accountcart .cartsec .buttonsec a:hover {
  text-decoration: none;
  border-bottom: 1px solid #303030;
}

header .inner_header .search-account .accountcart .cartsec .buttonsec a .viewcart {
  height: 16px;
  width: 16px;
  margin-right: 8px;
  margin-top: -4px;
}

header .inner_header .search-account .accountcart .impersonatesec{
  padding-right: 30px;
}

header .inner_header .search-account .accountcart .impersonatesec button,.mobilemenu .impersonatesec a.btn{
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  margin: 0;
  padding: 0px 24px;
  border-radius: 5px;
  background: #303030;
  color: #fff;
  font-family: "Spartan", sans-serif;
  font-weight: 600;
  text-transform: uppercase;
}

.impersonate_search button svg path{
  fill: #fff;
}
.impersonate_search button:hover svg path{
  fill: #303030;
}

header .inner_header .search-account .accountcart .accountsec {
  position: relative;
  line-height: 34px;
  display: inline-block;
}

header .inner_header .search-account .accountcart .accountsec ul {
  position: absolute;
  width: 100%;
  background: #fff;
  border: 1px solid #d2d2d2;
  padding: 0 15px;
  box-sizing: border-box;
  z-index: 1;
  min-width: 215px;
  top: 34px;
  right: -20px;
  display: none;
}

header .inner_header .search-account .accountcart .accountsec ul li {
  line-height: 55px;
  border-bottom: 1px solid #202020;
}

header .inner_header .search-account .accountcart .accountsec ul li a {
  font-weight: normal;
  font-size: 14px;
  color: #303030;
  margin: 0;
  line-height: normal;
  width: 100%;
}

header .inner_header .search-account .accountcart .accountsec a {
  color: #303030;
  font-size: 14px;
  text-decoration: none;
  margin-right: 30px;
  line-height: 34px;
  display: inline-block;
  font-weight: 400;
}

header .inner_header .search-account .accountcart .accountsec ul li a:hover {
  font-weight: 600;
}

header .inner_header .search-account .accountcart .accountsec ul li a img.signout {
  height: 13px;
  width: 13px;
  position: relative;
  top: -1px;
  left: -6px;
}

header .inner_header .search-account .accountcart .accountsec ul li:last-child {
  border-bottom: 0;
  text-align: center;
}

header .inner_header .search-account .accountcart .accountsec ul li:last-child a {
  font-weight: 600;
  width: auto;
}

header .inner_header .search-account .accountcart .accountsec ul li:last-child a:hover {
  border-bottom: 1px solid #303030;
}

header .inner_header .search-account .accountcart .accountsec:hover ul {
  display: block;
}

header .search-account .accountcart img.headimg {
  width: 14px;
  height: 16px;
  margin-right: 10px;
  position: relative;
  top: 0;
}

header .search-account .accountcart .cartsec a img.headimg {
  margin-right: 0;
  width: 20px;
  height: 18px;
  top: 1px;
}

header .inner_header .search-account .accountcart .accountsec a {
  color: #303030;
  font-size: 14px;
  text-decoration: none;
  margin-right: 30px;
  line-height: 34px;
  display: inline-block;
  font-weight: 400;
}

header .inner_header .search-account .searchform .searchimg {
  min-width: 120px;
  display: none;
}

header .inner_header .search-account .searchform .searchimg a {
  color: #777777;
  font-size: 12px;
  text-decoration: none;
  float: right;
  opacity: 1;
}

header .inner_header .search-account .searchform .searchimg a:hover {
  opacity: 0.8;
}

header .inner_header .search-account .searchform .searchimg a>div {
  border: 1px solid #d2d2d2;
  display: inline-block;
  text-align: center;
  height: 30px;
  width: 30px;
  margin-right: 12px;
  border-radius: 3px;
}

header .inner_header .search-account .searchform .searchimg a>span {
  position: relative;
  top: -9px;
  color: #777777;
}

header .inner_header .search-account .searchform .searchimg a .cameraicn {
  width: 18px;
  height: 19px;
  float: left;
  margin-top: 4px;
  margin-left: 5px;
}

header .inner_header .navigation-top ul>li .wrapview {
  display: none;
  position: absolute;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 1001;
  top: 119px;
  border: 1px solid #d2d2d2;
  padding: 0px 50px;
}

header .inner_header .navigation-top ul>li.hardware_item:hover .wrapview {
  height: 100%;
  min-height: 400px;
}

header .inner_header .navigation-top ul>li .wrapview ul li,
header .inner_header .navigation-top ul>li .wrapview ul li a {
  height: auto;
  line-height: normal;
}

header .inner_header .navigation-top ul>li .wrapview ul.sub-menu li {
  float: left;
  width: 50%;
  margin-bottom: 15px;
  padding: 0;
}
header .inner_header .navigation-top ul>li.fabric_item .wrapview ul.sub-menu li{
  width: 225px;
}
header .inner_header .navigation-top ul>li.trim_item .wrapview ul.sub-menu li,
header .inner_header .navigation-top ul>li.hardware_item .wrapview ul.sub-menu li{
  width:100%;
}
header .inner_header .navigation-top ul>li .wrapview ul li a {
  font-weight: 600;
  font-weight: 600;
  float: left;
  line-height: 22px;
  width: auto;
  border-bottom: 1px solid #fff;
}

header .inner_header .navigation-top ul>li .wrapview ul li a::before {
  display: none;
}

header .inner_header .navigation-top ul>li .wrapview ul.sub-menu {
  float: left;
  width: 300px;
  padding-left: 0;
  box-sizing: border-box;
  padding-top: 30px;
}

header .inner_header .navigation-top ul>li .wrapview ul.sub-menu li a:hover {
  text-shadow: none;
  font-weight: 600;
  border-bottom: 1px solid #303030;
}

header .inner_header .navigation-top ul>li .wrapview .fabric-filters,
header .inner_header .navigation-top ul>li .wrapview .trim-filters,
header .inner_header .navigation-top ul>li .wrapview .hardware-filters {
  display: flex;
  justify-content: left;
}
header .inner_header .navigation-top ul>li .wrapview .fabric-filters{
  width: calc(100% - 450px);
}
header .inner_header .navigation-top ul>li .wrapview .trim-filters{
  width: calc(100% - 270px);
}
header .inner_header .navigation-top ul>li .wrapview .fabric-filters::after,
header .inner_header .navigation-top ul>li .wrapview .trim-filters::after,
header .inner_header .navigation-top ul>li .wrapview .hardware-filters::after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  background: url(/shop/images/fabric-menu-bg.jpeg);
  background-size: cover;
  width: 225px;
  height: 100%;
}

header .inner_header .navigation-top ul>li .wrapview .trim-filters::after {
  background: url(/shop/images/trimimg.jpg);
  background-size: cover;
  width: 270px;
  height: 100%;
}

header .inner_header .navigation-top ul>li .wrapview .hardware-filters::after {
  background: url(/shop/images/hardwareimg.jpg);
  background-size: cover;
  width: 320px;
  height: 100%;
}

header .inner_header .navigation-top ul>li .wrapview ul.sub-menu li.smeshops {
  overflow: hidden;
}

header .inner_header .navigation-top ul>li .wrapview ul.sub-menu li.smeshops>a,
header .inner_header .navigation-top ul>li .wrapview ul.sub-menu li.hofforms>a,
header .inner_header .navigation-top ul>li .wrapview ul.sub-menu li.esc_sub_links>a {
  margin-bottom: 15px;
}

header .inner_header .navigation-top ul>li .wrapview ul.sub-menu li.hofforms {
  overflow: hidden;
}
header .inner_header .navigation-top ul>li .wrapview ul.sub-menu li.colorworksfabricmenu {
  padding-top: 53px;
}
header .inner_header .navigation-top ul>li .wrapview .fabric-filters div,
header .inner_header .navigation-top ul>li .wrapview .hardware-filters div {
  width: 225px;
}

header .inner_header .navigation-top ul>li .wrapview .trim-filters div{
  width: 270px;
}

header .inner_header .navigation-top ul>li .wrapview .fabric-filters div h4,
header .inner_header .navigation-top ul>li .wrapview .trim-filters div h4,
header .inner_header .navigation-top ul>li .wrapview .hardware-filters div h4 {
  font-size: 14px;
  color: #303030;
  margin: 0;
  padding: 0;
  line-height: 22px;
  font-weight: 600;
  padding-top: 30px;
  padding-bottom: 20px;
  text-transform: capitalize;
  text-align: left;
}

header .inner_header .navigation-top ul>li .wrapview .fabric-filters div ul,
header .inner_header .navigation-top ul>li .wrapview .trim-filters div ul,
header .inner_header .navigation-top ul>li .wrapview .hardware-filters div ul {
  padding-bottom: 40px;
  display: inline-block;
}

header .inner_header .navigation-top ul>li .wrapview .fabric-filters div ul li,
header .inner_header .navigation-top ul>li .wrapview .trim-filters div ul li,
header .inner_header .navigation-top ul>li .wrapview .hardware-filters div ul li {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 15px;
}

header .inner_header .navigation-top ul>li .wrapview .fabric-filters div ul li:last-child a,
header .inner_header .navigation-top ul>li .wrapview .trim-filters div ul li:last-child a,
header .inner_header .navigation-top ul>li .wrapview .hardware-filters div ul li:last-child a {
  font-weight: 600;
  margin-top: 20px;
  line-height: normal;
  border-bottom: 1px solid #fff;
}

header .inner_header .navigation-top ul>li .wrapview .fabric-filters div ul li:last-child a:hover,
header .inner_header .navigation-top ul>li .wrapview .trim-filters div ul li:last-child a:hover,
header .inner_header .navigation-top ul>li .wrapview .hardware-filters div ul li:last-child a:hover {
  border-bottom: 1px solid #303030;
  text-shadow: none;
}

header .inner_header .navigation-top ul>li .wrapview .fabric-filters div ul li a,
header .inner_header .navigation-top ul>li .wrapview .trim-filters div ul li a,
header .inner_header .navigation-top ul>li .wrapview .hardware-filters div ul li a {
  font-size: 14px;
  color: #303030;
  line-height: 22px;
  margin: 0;
  padding: 0;
  width: auto;
  font-weight: normal;
}

header .inner_header .navigation-top ul>li .wrapview .fabric-filters div ul li a:hover,
header .inner_header .navigation-top ul>li .wrapview .trim-filters div ul li a:hover,
header .inner_header .navigation-top ul>li .wrapview .hardware-filters div ul li a:hover {
  /* font-weight: 600; */
  text-shadow: 0px 0px 1px #303030;
}

header .inner_header .navigation-top ul>li.sub_furniture .wrapview ul.sub-menu,
header .inner_header .navigation-top ul>li.sub_hardware .wrapview ul.sub-menu,
header .inner_header .navigation-top ul>li.menucustomprint .wrapview ul.sub-menu,
header .inner_header .navigation-top ul>li.hardware_item .wrapview ul.sub-menu {
  width: 50%;
}

header .inner_header .navigation-top ul>li.fabric_item .wrapview ul.sub-menu {
  width: 450px;
}
header .inner_header .navigation-top ul>li.trim_item .wrapview ul.sub-menu {
  width: 270px;
}

header .inner_header .navigation-top ul>li.sub_contract .wrapview ul.sub-menu {
  width: 40%;
}

header .inner_header .navigation-top ul>li.sub_furniture .wrapview ul.sub-menu,
header .inner_header .navigation-top ul>li.fabric_item .wrapview ul.sub-menu,
header .inner_header .navigation-top ul>li.hardware_item .wrapview ul.sub-menu {
  column-count: 2;
  column-gap: 0;
}

header .inner_header .navigation-top ul>li.sub_furniture.sub_workroom.sub_contract .wrapview ul.sub-menu {
  column-gap: 0;
}

header .inner_header .navigation-top ul>li.hidemenu {
  display: none;
}

header .inner_header .navigation-top ul>li.sub_furniture .wrapview ul.sub-menu li ul.sub-menu,
header .inner_header .navigation-top ul>li.fabric_item .wrapview ul.sub-menu li ul.sub-menu,
header .inner_header .navigation-top ul>li.hardware_item .wrapview ul.sub-menu li ul.sub-menu {
  position: relative;
  right: inherit;
  top: 5px;
  border: none;
  display: block;
  padding: 0;
  background: transparent;
  column-count: inherit;
  column-gap: inherit;
  width: auto;
}

header .inner_header .navigation-top ul>li.sub_furniture .wrapview ul.sub-menu li {
  margin-right: 65px;
  width: auto;
}
header .inner_header .navigation-top ul>li.sub_furniture.sub_shades .wrapview ul.sub-menu li{
  width:100%;
}
header .inner_header .navigation-top ul>li.sub_furniture .wrapview ul.sub-menu li.esc_sub_links{
  overflow: hidden;
}
header .inner_header .navigation-top ul>li.sub_furniture .wrapview ul.sub-menu li.rs_shades_link{
  height:200px;
}
header .inner_header .navigation-top ul>li.sub_contract .wrapview ul.sub-menu li.menu-item-748 a {
  width: 180px;
}

header .inner_header .navigation-top ul>li.sub_company .wrapview ul.sub-menu li.menu-item-314 {
  margin-bottom: 52px;
}

header .inner_header .navigation-top ul>li.sub_workroom .wrapview ul.sub-menu li.menu-item-233 {
  margin-top: 40px;
}

header .inner_header .navigation-top ul>li.sub_furniture.sub_workroom .wrapview ul.sub-menu li {
  margin-right: 0;
  width: 100%;
  position: relative;
}

header .inner_header .navigation-top ul>li.sub_furniture .wrapview ul.sub-menu li:last-child {
  margin: 0;
  position: relative;
}

header .inner_header .navigation-top ul>li.sub_furniture.furniture_drop .wrapview ul.sub-menu li {
  margin-right: 65px;
}

header .inner_header .navigation-top ul>li.sub_furniture .wrapview ul.sub-menu li ul.sub-menu li {
  margin: 0 0px 3px 0;
  width: 100%;
  float: none;
}

header .inner_header .navigation-top ul>li.sub_furniture .wrapview ul.sub-menu li ul.sub-menu li a,
header .inner_header .navigation-top ul > li.fabric_item .wrapview ul.sub-menu li ul.sub-menu li a,
header .inner_header .navigation-top ul > li.hardware_item .wrapview ul.sub-menu li ul.sub-menu li a {
  font-weight: normal;
}

header .inner_header .navigation-top ul>li .wrapview .furniture-images {
  display: flex;
  justify-content: space-between;
  width: 50%;
  margin: 40px 0;
  gap: 30px;
}

header .inner_header .navigation-top ul>li .wrapview .furniture-images .cw-logo {
  position: absolute;
  width: 30%;
  left: 50px;
  bottom: 20px;
}

header .inner_header .navigation-top ul>li .wrapview .furniture-images .cw-logo img {
  width: 100%;
  height: auto;
}

header .inner_header .navigation-top ul>li .wrapview .furniture-images .metrosec,
header .inner_header .navigation-top ul>li .wrapview .furniture-images .sonomasec {
  width: 50%;
  position: relative;
}

header .inner_header .navigation-top ul>li .wrapview .furniture-images .metrosec div,
header .inner_header .navigation-top ul>li .wrapview .furniture-images .sonomasec div {
  height: 325px;
  width: 100%;
  background-size: cover;
  border-radius: 3px;
}

header .inner_header .navigation-top ul>li .wrapview .furniture-images .metrosec h4,
header .inner_header .navigation-top ul>li .wrapview .furniture-images .sonomasec h4 {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff !important;
  position: absolute;
  bottom: 42px;
  right: 30px;
  line-height: normal;
}

.cocomatch_pop {
  position: fixed;
  width: 480px;
  height: 480px;
  background: #ececec;
  z-index: 1;
  left: 50%;
  transform: translate(-50%, 0);
  top: 30%;
  padding: 20px;
  box-sizing: border-box;
  display: none;
}

.cocomatch_pop h5 {
  display: inline-block;
  font-size: 16px;
  color: #303030;
  font-weight: 400;
}

.cocomatch_pop .close_pop {
  float: right;
  height: 10px;
  width: 10px;
}

li.withnewtag>a::after {
  content: ' NEW!';
  color: #f00;
}

@media only screen and (max-width: 1440px) {

  .container,
  header .container {
    max-width: 1200px;
  }

  header .logosec {
    margin-right: 35px;
  }

  header .inner_header .search-account {
    width: 80.7%;
  }

  header .inner_header .navigation-top ul>li {
    padding: 0 28px;
  }

  header .inner_header .navigation-top ul>li .wrapview::before {
    left: 12px;
  }

  /*header .inner_header .navigation-top ul > li.sub_furniture .wrapview ul.sub-menu{
    width: 400px;
  }*/
  header .inner_header .navigation-top ul>li.sub_furniture .wrapview ul.sub-menu {
    padding-bottom: 35px;
  }

  header .inner_header .navigation-top ul>li.sub_furniture .wrapview ul.sub-menu li {
    margin-right: 45px;
    width: 100%;
  }

  header .inner_header .navigation-top ul>li.sub_furniture .wrapview ul.sub-menu, 
  header .inner_header .navigation-top ul>li.sub_hardware .wrapview ul.sub-menu, 
  header .inner_header .navigation-top ul>li.menucustomprint .wrapview ul.sub-menu, 
  header .inner_header .navigation-top ul>li.hardware_item .wrapview ul.sub-menu{
    width: 50%;
  }

  header .inner_header .navigation-top ul>li .wrapview .furniture-images .cw-logo {
    left: 20px;
  }

  header .inner_header .navigation-top ul>li.sub_contract .wrapview .furniture-images {
    width: 50%;
  }

  header .inner_header .navigation-top ul>li .wrapview .furniture-images .metrosec div,
  header .inner_header .navigation-top ul>li .wrapview .furniture-images .sonomasec div {
    height: 285px;
  }
}

@media only screen and (max-width: 1440px) and (min-width: 1200px) {
  header .inner_header .navigation-top ul>li {
    padding: 0 25px;
  }
  header .inner_header .navigation-top ul>li .wrapview{
    padding: 0 40px;
  }
  header .inner_header .navigation-top ul>li.fabric_item .wrapview ul.sub-menu{
    width: 386px;
  }
  header .inner_header .navigation-top ul>li .wrapview ul.sub-menu li{
    width: 50%;
  }
  header .inner_header .navigation-top ul>li.fabric_item .wrapview ul.sub-menu li{
    width: 193px;
  }
  header .inner_header .navigation-top ul>li .wrapview .fabric-filters{
    width: calc(100% - 386px);
  }
  header .inner_header .navigation-top ul>li .wrapview .fabric-filters div{
    width: 193px;
  }
  header .inner_header .navigation-top ul>li .wrapview .fabric-filters::after{
    width: 193px;
  }
  header .inner_header .navigation-top ul>li.trim_item .wrapview ul.sub-menu{
    width: 232px;
  }
  header .inner_header .navigation-top ul>li .wrapview .trim-filters{
    width: calc(100% - 232px);
  }
  header .inner_header .navigation-top ul>li.trim_item .wrapview ul.sub-menu li,
  header .inner_header .navigation-top ul>li.trim_item .wrapview .trim-filters div,
  header .inner_header .navigation-top ul>li .wrapview .trim-filters::after{
    width: 232px;
  }
  header .inner_header .navigation-top ul>li.hardware_item .wrapview ul.sub-menu li{
    width: 100%;
  }
}

@media only screen and (max-width: 1199px) and (min-width: 1025px) {
  .container {
    max-width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }

  header .inner_header .search-account {
    width: 76.6%;
    float: left;
  }

  header .inner_header .navigation-top ul>li {
    padding: 0 12px;
  }
  header .inner_header .navigation-top ul>li .wrapview{
    padding: 0 20px;
  }
  header .inner_header .navigation-top ul>li .wrapview ul.sub-menu {
    width: 250px;
  }
  header .inner_header .navigation-top ul>li.fabric_item .wrapview ul.sub-menu{
    width:40%;
  }
  header .inner_header .navigation-top ul>li.fabric_item .wrapview ul.sub-menu li{
    width: 100%;
  }
  header .inner_header .navigation-top ul>li .wrapview .fabric-filters{
    width: 60%;
  }
  header .inner_header .navigation-top ul>li.trim_item .wrapview ul.sub-menu{
    width: 25%;
  }
  header .inner_header .navigation-top ul>li .wrapview .trim-filters{
    width: 75%;
  }
  header .inner_header .navigation-top ul>li .wrapview .fabric-filters::after,
  header .inner_header .navigation-top ul>li .wrapview .trim-filters::after,
  header .inner_header .navigation-top ul>li .wrapview .hardware-filters::after {
    display: none;
  }

  header .inner_header .navigation-top ul>li .wrapview .fabric-filters div, 
  header .inner_header .navigation-top ul>li .wrapview .trim-filters div, 
  header .inner_header .navigation-top ul>li .wrapview .hardware-filters div {
    width: 33.33%;
  }

  header .inner_header .navigation-top ul>li .wrapview .furniture-images .metrosec div,
  header .inner_header .navigation-top ul>li .wrapview .furniture-images .sonomasec div {
    height: 220px;
  }
}

@media only screen and (max-width:1024px) and (min-width:768px) {
  .bm-overlay::after {
    content: '';
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .3);
    z-index: 11;
  }

  header .container img {
    width: 130px;
    height: 41px;
  }

  header .logosec {
    margin-right: 15px;
    margin-left: 38px;
    margin-top: 0;
    margin-bottom: 0;
    position: relative;
    z-index: 1;
  }

  header .inner_header {
    display: flex;
    align-items: center;
  }

  header .inner_header,
  header.site-header {
    height: 70px;
  }

  header .inner_header .search-account .accountcart,
  header .inner_header .search-account .searchform {
    margin-top: 0;
  }

  .mobilemenu {
    display: block;
    position: relative;
    z-index: 12;
  }

  .mobilemenu .bm-burger-button {
    cursor: pointer;
    height: 20px;
    top: -44px;
    width: 24px;
    left: 25px;
  }

  header.site-header.headfix+.mobilemenu .bm-burger-button {
    top: 22px;
    position: fixed;
  }

  .mobilemenu .bm-item-list {
    font-size: 14px;
    margin-left: 0;
  }

  .mobilemenu .bm-item-list div:nth-child(7) {
    display: none;
  }

  .mobilemenu .bm-burger-button .line-style {
    height: 20%;
  }

  .mobilemenu .bm-cross {
    background: #303030;
    height: 18px !important;
    width: 2px !important;
  }

  .mobilemenu .bm-menu {
    background: #ffffff;
  }

  .mobilemenu .bm-item-list>*>span {
    color: #303030;
    font-weight: 500;
    margin-left: 0;
  }

  .mobilemenu ul.submoboptions {
    width: 100%;
    flex-wrap: wrap;
  }

  .mobilemenu ul.submoboptions li {
    width: 100%;
    line-height: 34px;
  }

  .mobilemenu ul.submoboptions li a {
    width: 100%;
    color: #303030;
    font-weight: normal;
  }

  .mobilemenu .bm-item-list a {
    justify-content: space-between;
    text-decoration: none !important;
    width: 100%;
    display: flex;
    color: #303030;
    font-weight: 500;
  }

  .mobilemenu .bm-item-list>div {
    flex-wrap: wrap;
  }

  .mobilemenu .bm-item-list .collapse.show {
    padding-top: 20px;
    width: 100%;
  }

  .mobilemenu .bm-item-list .submoboptions .collapse.show {
    padding-top: 0;
  }

  .mobilemenu .bm-item-list a.collapsed img.submenuarrow {
    transform: rotate(-90deg);
    height: 12px;
    width: 12px;
    margin-top: 4px;
  }

  .mobilemenu .bm-item-list img.submenuarrow {
    transform: rotate(0);
    height: 12px;
    width: 12px;
    margin-top: 4px;
  }

  header .inner_header .navigation-top {
    display: none;
  }

  header .inner_header .search-account {
    width: 80.7%;
  }

  header .inner_header .search-account .searchform .searchsite {
    max-width: 280px;
    margin-right: 25px;
    min-width: 280px;
    margin-top: 3px;
  }

  header .inner_header .search-account .searchform input {
    max-width: 280px;
  }
}

@media only screen and (max-width:767px) {
  .head_top {
    display: none;
  }

  .head_top p {
    font-size: 10px;
  }

  .headwrap.positionfix+.container {
    margin-top: 180px;
  }

  .bm-overlay::after {
    content: '';
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .3);
    z-index: 11;
  }

  header .container img {
    width: 130px;
    height: 41px;
  }

  header .logosec {
    position: relative;
    z-index: 1;
    float: none;
    margin: 0 auto;
    text-align: center;
    padding: 10px 0 10px 0;
    max-width: 130px;
  }

  header .inner_header,
  header.site-header {
    height: 110px;
  }

  .mobilemenu {
    display: block;
    position: relative;
    z-index: 12;
  }

  .mobilemenu .bm-burger-button {
    cursor: pointer;
    height: 20px;
    top: -88px;
    width: 24px;
    left: 20px;
  }

  header.site-header.headfix+.mobilemenu .bm-burger-button {
    top: 22px;
    position: fixed;
  }

  header .inner_header .search-account .accountcart .accountsec a>span {
    display: none;
  }

  header .inner_header .search-account .accountcart .cartsec {
    top: -1px;
  }

  header .search-account .accountcart .accountsec a img.headimg {
    opacity: 0.5;
    width: 18px;
    height: 16px;
  }

  header .search-account .accountcart .accountsec a.isloggedin img.headimg {
    opacity: 1;
  }

  header .inner_header .search-account .accountcart .cartsec .cartboxcontent h3 {
    width: 90%;
  }

  header .inner_header .search-account .accountcart .cartsec .cartboxcontent .bookmarkprice h3 {
    width: auto;
  }

  .mobilemenu .bm-item-list {
    font-size: 14px;
    margin-left: 0;
  }

  .mobilemenu .bm-burger-button .line-style {
    height: 20%;
  }

  .mobilemenu .bm-cross {
    background: #303030;
    height: 18px !important;
    width: 2px !important;
  }

  .mobilemenu .bm-menu {
    background: #ffffff;
  }

  .mobilemenu .bm-item-list>*>span {
    color: #303030;
    font-weight: 500;
    margin-left: 0;
  }

  .mobilemenu ul.submoboptions {
    width: 100%;
    flex-wrap: wrap;
  }

  .mobilemenu ul.submoboptions li {
    width: 100%;
    line-height: 34px;
  }

  .mobilemenu ul.submoboptions li a {
    width: 100%;
    color: #303030;
    font-weight: normal;
  }

  .mobilemenu .bm-item-list a {
    justify-content: space-between;
    text-decoration: none !important;
    width: 100%;
    display: flex;
    color: #303030;
    font-weight: 500;
  }

  .mobilemenu .bm-item-list>div {
    flex-wrap: wrap;
  }

  .mobilemenu .bm-item-list .collapse.show {
    padding-top: 20px;
    width: 100%;
  }

  .mobilemenu .bm-item-list .submoboptions .collapse.show {
    padding-top: 0;
  }

  .mobilemenu .bm-item-list a.collapsed img.submenuarrow {
    transform: rotate(-90deg);
    height: 12px;
    width: 12px;
    margin-top: 4px;
  }

  .mobilemenu .bm-item-list img.submenuarrow {
    transform: rotate(0);
    height: 12px;
    width: 12px;
    margin-top: 4px;
  }

  header .inner_header .navigation-top {
    display: none;
  }

  header .inner_header .search-account {
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-end;
    position: relative;
    top: -46px;
  }

  header .inner_header .search-account .searchform {
    order: 2;
    width: 100%;
  }

  header .inner_header .search-account .searchform .searchsite {
    min-width: 100%;
    max-width: 100%;
    margin-right: 0;
  }

  header .inner_header .search-account .accountcart {
    width: 100%;
    justify-content: flex-end;
  }

  header .inner_header .search-account .accountcart .accountsec a {
    font-size: 12px;
    margin-right: 10px;
  }

  header .search-account .accountcart img.headimg {
    margin-right: 4px;
    position: relative;
    top: -2px;
  }

  header .search-account .accountcart .cartsec a img.headimg {
    width: 18px;
    height: 16px;
  }

  header .inner_header .search-account .accountcart .cartsec a .itemcount {
    height: 15px;
    width: 15px;
  }

  header .inner_header .search-account .accountcart .cartsec .cartitems {
    width: 300px;
  }

  header .inner_header .search-account .accountcart .cartsec .cartitems .iteminfo {
    margin: 0 12px;
  }

  header .inner_header .search-account .accountcart .cartsec .cartboxcontent .bookmarkprice h3 {
    margin-top: 0;
  }

  header .inner_header .search-account .accountcart .cartsec .cartitems .ps {
    height: 245px;
  }

  header .inner_header .search-account .accountcart .cartsec .cartitems .iteminfo .cartboximg {
    height: 100px;
    width: 100px;
  }

  header .inner_header .search-account .accountcart .cartsec .cartboxcontent {
    width: 56%;
  }
}
</style>